export function setIsSavingSeatedPatientTransport(state, payload) {
  state.isSavingTreatmentAbroad = payload;
}
